import { render, staticRenderFns } from "./BisnisUnitName.vue?vue&type=template&id=92b40942&"
import script from "./BisnisUnitName.vue?vue&type=script&lang=js&"
export * from "./BisnisUnitName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports